import TextField from "../../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import ConfirmDialog from "../../../../components/dialog/confirm/ConfirmDialog.vue"
import moment from "moment";
import { SnackBarModule } from "../../../../modules/SnackBarModule";
import { SolicitarFeriasCivilService } from "../../../../services/SolicitarFeriasCivilService";
import { FeriasCivilService } from "../../../../services/FeriasCivilService";

import { date, strtotime } from "date-typescript-library";
import { tipoPerfil } from "../../../../constants";



export default {
  name: "SolicitarFeriasCivil",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    ConfirmDialog
  },
  props:{
    selected:{
      default:""
    }
  },
  
  data: () => ({
    form: {},
    campos: 0,
    confirmDialog: false,
    saldoExercicio:0,

    diasRestantes: 0,

    role: "",

    exerciciosOptions: [],
    responsavelOptions:[],

    limitePeriodo: false,

    responsavel:[],
    loading: {
      field: false,
      btn: false
    },
    feriasCassadasPorExercicio: {} // Novo campo para armazenar o status de férias cassadas
  }),

  beforeMount() {
    this.role = this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1;
    
    if(this.$store.state.user.Civil){
      this.role = this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1;
    }
    this.initializeForm();
    this.pegarDiasRestantesDaParecela();
  },

  mounted() {
    this.getExercicioItems();
    this.getResponsavelItems();

  },

  watch:{
   campos(value){
    if(this.$store.state.user.Civil){
      this.limitePeriodo =  value >=2;
    }
   }
  },

  computed: {
    desabilitarBotaoNovaParcela() {
      if (this.form.length >= 2) {
        return true; 
      }
  
      let totalDiasSolicitados = this.form.reduce((total, parcela) => total + parseInt(parcela.numeroDias || 0), 0);
  
      if (totalDiasSolicitados >= 25) {
        return true; 
      }
  
      return false;
    }
  },
  

  methods: {
    async pegarDiasRestantesDaParecela(index,event) {
      this.form[index].subtitulo = "Por favor selecione um exercício";

      event != undefined ? this.form[index].exercicio = event : ""
      
      // Verificar se há férias cassadas para este exercício ANTES de continuar
      if (event) {
        console.log('Chamando verificarFeriasCassadas para exercício:', event);
        await this.verificarFeriasCassadas(event);
        console.log('Verificação concluída, feriasCassadasPorExercicio:', this.feriasCassadasPorExercicio);
      }

      const formData = new FormData();

      formData.append('exercicio', this.form[index].exercicio);
      const response = await SolicitarFeriasCivilService.pegarDiasRestantes(formData);
      
      if(response.exercicio != null){
        this.saldoExercicio = response.dias;
        this.form[index].subtitulo = `Você possui um saldo de ${response.dias} dia(s) no exercício ${response.exercicio}`
        
        // Verificar se há férias cassadas para este exercício
        if (event) {
          await this.verificarFeriasCassadas(event);
        }
      }

        //Update no forms inteiro para pode atualizar os valores
        this.form[this.campos] = {}
        this.form.pop()
    },

    async getExercicioItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getExercicio();
      this.exerciciosOptions = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.exerciciosOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },
    async getResponsavelItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getCivilResponsavel();
      this.responsavelOptions = response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });
      this.responsavelOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },

    async calculateDays(index) {
      
      if (this.form[index].dataInicio) {
        // PRIMEIRO: Verificar se há férias cassadas para o exercício
        const exercicio = this.form[index]?.exercicio;
        if (exercicio && !(exercicio in this.feriasCassadasPorExercicio)) {
          await this.verificarFeriasCassadas(exercicio);
        }

        const formData = new FormData();
        formData.append("data_ini", moment(this.form[index].dataInicio).format("YYYY-MM-DD"));
        formData.append("dias",this.form[index].numeroDias);
        const response = await SolicitarFeriasCivilService.calcularDiasUteis(formData);
        
        const diasSolicitados = parseInt(response.dias_uteis);
        
        // Validar se a quantidade solicitada não deixará saldo impossível de usar
        const saldoAposOperacao = this.saldoExercicio - diasSolicitados;
        if (saldoAposOperacao > 0 && saldoAposOperacao < 10) {
          SnackBarModule(`Não é possível solicitar ${diasSolicitados} dias pois sobraria um saldo de ${saldoAposOperacao} dias que não poderia ser utilizado. Com saldo de ${this.saldoExercicio} dias, você deve solicitar ${this.saldoExercicio} dias.`, "error");
          return;
        }

        // Se é o primeiro período
        if (index === 0) {
          // Verificar se há férias cassadas para o exercício selecionado
          const temFeriasCassadas = exercicio && this.feriasCassadasPorExercicio[exercicio];
  
          // Só aplica a validação de dias específicos se NÃO há férias cassadas
          if (!temFeriasCassadas && ![10, 15, 25].includes(diasSolicitados)) {
            SnackBarModule("O número de dias deve ser 10, 15 ou 25.", "error");
            return;
          }

          // Se o saldo é menor que 25, só pode solicitar o saldo exato
          if (this.saldoExercicio < 25 && diasSolicitados !== this.saldoExercicio) {
            SnackBarModule(`Com saldo de ${this.saldoExercicio} dias, você deve solicitar exatamente ${this.saldoExercicio} dias.`, "error");
            return;
          }
        } 
        // Se é o segundo período
        else {
          const primeiroPeriodo = parseInt(this.form[0].numeroDias) || 0;
          
          if (primeiroPeriodo === 10 && diasSolicitados !== 15) {
            SnackBarModule("Após uma parcela de 10 dias, a segunda parcela deve ser de 15 dias.", "error");
            return;
          }
          
          if (primeiroPeriodo === 15 && diasSolicitados !== 10) {
            SnackBarModule("Após uma parcela de 15 dias, a segunda parcela deve ser de 10 dias.", "error");
            return;
          }
        }

        this.form[index].dataFim = response.dataFim;
        this.form[index].numeroDias = response.dias_uteis;
        const doisMeses = date("Y-m-d",strtotime("+ 2 MONTHS"));
        this.confirmDialog = doisMeses > moment(this.form[index].dataInicio).format("YYYY-MM-DD")
        this.regraDoisMesesAnterior = doisMeses > moment(this.form[index].dataInicio).format("YYYY-MM-DD")
        
        //Update no forms inteiro para pode atualizar os valores
        this.form[this.campos] = {}
        this.form.pop()

        return this.calcularTotalDiasRestantes();
      }
      return SnackBarModule("Preencha o campo de data inicial", "error");
    },

    calcularTotalDiasRestantes(){
      this.diasRestantes = 25;
      this.form.forEach( (value) =>{
          this.diasRestantes = this.diasRestantes - parseInt(value.numeroDias)
          if(this.diasRestantes < 0){
            return SnackBarModule("Número de dias dos períodos solicitados juntos devem ser menor que 25", "error");

          }
      })
      return;
    },

    verificarSeTodasDatasIniciasSaoMenoresQueUltimaDataFinal(){
      if(this.campos > 1){
       this.form.forEach((value)=>{
        if(this.form[this.campos-1].dataInicio < value.dataFim){
          return SnackBarModule("A data início deverá ser maior que a data final da última parcela", "error");
        }
       })
      }
      return;
    },

    calculateFinalDate(index) {
  
      const finalDate = moment(this.form[index].dataInicio).add(this.form[index].numeroDias, 'days');
      if (this.form[index].dataInicio) {
        return this.form[index].dataFim = moment(finalDate).format("YYYY-MM-DD");
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    cleanCalculate(index) {
      this.form[index].dataFim = null;
      this.form[index].numeroDias = null;
      SnackBarModule("Preencha os outros campos para realizar o cálculo", "error");
    },

    createNewForm() {
      if (this.campos >= 2) {
        SnackBarModule("O número máximo de parcelas permitidas é 2.", "error");
        return;
      }

      // Se o saldo é menor que 25, não permite adicionar nova parcela
      if (this.saldoExercicio < 25) {
        SnackBarModule(`Com saldo de ${this.saldoExercicio} dias, você deve solicitar todos os dias em uma única parcela.`, "error");
        return;
      }

      // Verificar o primeiro período para determinar se pode adicionar outro
      const primeiroPeriodo = parseInt(this.form[0].numeroDias) || 0;
      
      if (primeiroPeriodo === 25) {
        SnackBarModule("Não é possível adicionar outro período quando já solicitou 25 dias.", "error");
        return;
      }
      
      if (primeiroPeriodo === 15) {
        SnackBarModule("Após uma parcela de 15 dias, não é possível adicionar outra parcela.", "error");
        return;
      }

      if (primeiroPeriodo === 10) {
        // Se já tem 10 dias, o próximo só pode ser 15
        this.campos += 1;
        this.form.push({
          subtitulo: "Para este período, você deve solicitar 15 dias úteis",
          exercicio: "",
          dataInicio: null,
          dataFim: null,
          numeroDias: "15" // Pré-define 15 dias
        });
        return;
      }

      if (primeiroPeriodo === 0) {
        this.campos += 1;
        this.form.push({
          subtitulo: "Por favor selecione uma parcela de 10 ou 15 dias úteis",
          exercicio: "",
          dataInicio: null,
          dataFim: null,
          numeroDias: ""
        });
      }
    },

    prepareForm() {
      const formData = new FormData();
      let form = true;

      if (this.form.length > 2) {
        SnackBarModule("O número máximo de parcelas permitidas é 2.", "error");
        return;
      }

      let diasSolicitados = this.form.map(f => parseInt(f.numeroDias) || 0);
      let totalDias = diasSolicitados.reduce((a, b) => a + b, 0);

      // Validar se o total solicitado não deixará saldo impossível
      const saldoAposOperacao = this.saldoExercicio - totalDias;

  if (saldoAposOperacao > 0 && saldoAposOperacao < 10) {
    SnackBarModule(`Não é possível solicitar ${totalDias} dias pois sobraria um saldo de ${saldoAposOperacao} dias que não poderia ser utilizado. Com saldo de ${this.saldoExercicio} dias, você deve solicitar ${this.saldoExercicio} dias.`, "error");
    return;
  }
  
  // Verificar se há férias cassadas para o exercício
  const exercicio = this.form[0]?.exercicio;
  const temFeriasCassadas = exercicio && this.feriasCassadasPorExercicio[exercicio];
  
  // Validar combinações permitidas apenas se NÃO há férias cassadas
  if (!temFeriasCassadas) {
    if (diasSolicitados.length === 2) {
      const [primeiro, segundo] = diasSolicitados;
      
      // Se tem duas parcelas, só pode ser 10+15
      if (!(primeiro === 10 && segundo === 15) && !(primeiro === 15 && segundo === 10)) {
        SnackBarModule("Quando dividido em duas parcelas, deve ser uma parcela de 10 e outra de 15 dias úteis.", "error");
        return;
      }
    } else if (diasSolicitados.length === 1) {
      // Se é parcela única, pode ser 10, 15 ou 25
      if (![10, 15, 25].includes(diasSolicitados[0])) {
        SnackBarModule("Em parcela única, você deve solicitar 10, 15 ou 25 dias úteis.", "error");
        return;
      }

      // Se o saldo é menor que 25, só pode solicitar o saldo exato
      if (this.saldoExercicio < 25 && diasSolicitados[0] !== this.saldoExercicio) {
        SnackBarModule(`Com saldo de ${this.saldoExercicio} dias, você deve solicitar exatamente ${this.saldoExercicio} dias.`, "error");
        return;
      }
    }
  }

  this.form.forEach((element, index) => {
    if (!element.dataInicio || !element.dataFim || !element.exercicio || !element.numeroDias) {
      form = false;
      SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
      return;
    }

    if (this.saldoExercicio == 0) {
      form = false;
      SnackBarModule("Seu saldo de férias é 0.", "error");
      return;
    }

    if (this.regraDoisMesesAnterior) {
      form = false;
      SnackBarModule("O período inicial está anterior a dois meses da data de solicitação.", "error");
      return;
    }

    formData.append(`ferias[${index}][data_ini]`, moment(element.dataInicio).format("YYYY-MM-DD"));
    formData.append(`ferias[${index}][data_fin]`, moment(element.dataFim).format("YYYY-MM-DD"));
    formData.append(`ferias[${index}][exercicio]`, element.exercicio);
    formData.append(`ferias[${index}][id_tipo]`, 1);
    formData.append(`ferias[${index}][dias]`, element.numeroDias);
  });

  formData.append(`id_responsavel_ferias`, this.responsavel);

  if (form) {
    this.sendForm(formData);
  }
},

    removePeriodoFerias(){
      this.diasLimite = this.diasLimite + parseInt(this.form[this.campos-1].numeroDias )
      this.form.pop()
      this.campos = this.campos -1
      
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await SolicitarFeriasCivilService.postFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.initializeForm();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.campos = 1
      this.form = [
        {   
        subtitulo: "Por favor selecione uma parcela",
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }
      ]
    },

    close() {
      this.$emit("on-close");
    },

    // Método para verificar se deve aplicar a validação de dias
    deveAplicarValidacaoDias(exercicio) {
      return !this.feriasCassadasPorExercicio[exercicio];
    },

    getRulesForDias(index) {
      const exercicio = this.form[index]?.exercicio;
      const baseRules = [
        (v) => !!v || 'Campo obrigatório não informado.',
        (v) => !!(v > 0) || 'O número de dias deve ser maior que zero',
      ];

      // Se houver férias cassadas, não aplica a regra dos dias específicos
      if (exercicio && this.feriasCassadasPorExercicio[exercicio]) {
        return baseRules;
      }

      // Só aplica a validação de dias específicos se NÃO há férias cassadas
      if (exercicio) {
        baseRules.push(
          (v) => !!(v == 5 || v == 10 || v == 15 || v == 25) || 'O número de dias úteis solicitados deverá ser 10, 15 ou 25 dias.'
        );
      }

      return baseRules;
    },

    async verificarFeriasCassadas(exercicio) {
      const postData = new FormData();
      postData.append("exercicio", exercicio);
      try {
        const response = await FeriasCivilService.verificarFeriasCassadas(postData);
        if (response && response.tem_ferias_cassadas_ou_convocadas !== undefined) {
          this.$set(this.feriasCassadasPorExercicio, exercicio, response.tem_ferias_cassadas_ou_convocadas);
        } 
      } catch (error) {
        console.error('Erro ao verificar férias cassadas:', error);
        // Em caso de erro, assume que não há férias cassadas (comportamento padrão)
        this.$set(this.feriasCassadasPorExercicio, exercicio, false);
      }
    },
  }
};